import { useTranslation } from "react-i18next";
import CoolnetPageLayout from "./components/CoolnetPageLayout";
import Layout from "@/components/feature/Layout";
import SEO from "@/components/feature/SEO";
import { coolnetWhyVentracore } from "@/mocks/coolnet";

export default function WhyVentracorePage() {
  const { t } = useTranslation("home");

  return (
    <Layout>
      <SEO
        title="¿Por qué elegir Ventracore con Coolnet? | Ventra Core México"
        description="Somos especialistas en climatización para centros de datos y distribuidor autorizado Coolnet en México. Certificaciones ISO 9001, ISO 14001, CE y CCC."
        keywords="Coolnet distribuidor México, climatización centros de datos, Ventracore Coolnet, aire acondicionado precisión, refrigeración data center"
        canonical="https://ventracore.com.mx/coolnet/por-que-ventracore"
        schemas={[
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": "https://ventracore.com.mx/coolnet/por-que-ventracore#webpage",
            "url": "https://ventracore.com.mx/coolnet/por-que-ventracore",
            "name": "¿Por qué elegir Ventracore con Coolnet? | Ventra Core México",
            "isPartOf": { "@id": "https://ventracore.com.mx/#website" },
            "description": "Somos especialistas en climatización para centros de datos y distribuidor autorizado Coolnet en México.",
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Inicio",
                "item": "https://ventracore.com.mx/",
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Coolnet",
                "item": "https://ventracore.com.mx/coolnet",
              },
              {
                "@type": "ListItem",
                "position": 3,
                "name": "¿Por qué Ventracore?",
                "item": "https://ventracore.com.mx/coolnet/por-que-ventracore",
              },
            ],
          },
        ]}
      />
      <CoolnetPageLayout
        title={t("coolnetPage.why.title")}
        subtitle={t("coolnetPage.why.subtitle")}
      >
        <div className="max-w-4xl mx-auto">
          {coolnetWhyVentracore.paragraphs.map((paragraph, index) => (
            <p
              key={index}
              className={`text-sm md:text-base text-text-muted leading-relaxed text-justify ${
                index < coolnetWhyVentracore.paragraphs.length - 1 ? "mb-6" : ""
              }`}
            >
              {paragraph}
            </p>
          ))}

          {/* Certifications */}
          <div className="mt-12 bg-surface rounded-lg p-6 md:p-8">
            <h3 className="text-lg md:text-xl font-bold text-magenta mb-4 text-center uppercase tracking-wide">
              Certificaciones Coolnet
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {["ISO 9001", "ISO 14001", "CE", "CCC"].map((cert) => (
                <div
                  key={cert}
                  className="flex items-center justify-center gap-2 bg-white rounded-md py-3 px-4"
                >
                  <span className="w-5 h-5 flex items-center justify-center text-brandgreen">
                    <i className="ri-shield-check-line" />
                  </span>
                  <span className="text-sm font-semibold text-text">{cert}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Contact info */}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-text-muted">
            <span>
              {t("coolnetPage.contact.phone")}{" "}
              <a
                href="tel:+524772847060"
                className="text-magenta hover:underline"
              >
                +52 477 284 70 60
              </a>
            </span>
            <span className="hidden sm:inline">|</span>
            <span>
              {t("coolnetPage.contact.email")}{" "}
              <a
                href="mailto:comercial@ventracore.com.mx"
                className="text-magenta hover:underline"
              >
                comercial@ventracore.com.mx
              </a>
            </span>
          </div>
        </div>
      </CoolnetPageLayout>
    </Layout>
  );
}
